<template>
    <div>
        <p>No Site</p>
        <img src="/no-site.png" />
    </div>
</template>

<script>
export default {
    mounted () {
        document.body.innerHTML = '<img class="no-site" src="/no-site.png"/>'    
    }
}
</script>

<style>
.no-site {
    width: 360px;
    margin-left: calc(50% - 180px);    
    animation: drop 10s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
}
@keyframes drop {
    0% {
        transform: translateY(-230px);
    } 
    50% {
        transform: translateY(0px);
    }
    100% {
        transform: translateY(-230px);
    }
}
</style>
